import { Injectable } from '@angular/core';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserSystemAnnouncement } from '../models/notification/user-system-announcement.dto';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  getUserSystemAnnouncements() {
    const params = new HttpParams().set('spaceShortName', 'SIGN');
    return this.http.get<UserSystemAnnouncement[]>(
      `${this.rootUrl}/iotp/user/system-announcements`,
      { params }
    );
  }

  markSystemAnnouncementAsRead(announcementId: number) {
    const url = `${this.rootUrl}/iotp/user/system-announcements/${announcementId}/read`;
    return this.http.post<{ status: number; message: string }>(url, {});
  }
}
